import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

export default function Seo() {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);
  const query = urlParams.get('q') || '';
  let title = 'Ayush Sharma | Crum & Forster | Full-Stack Developer';
  const description =
    'Ayush Sharma, Full-Stack Developer at Crum & Forster (CNF) and formerly Dyaus Tech, Indore, India. Expert in MERN, Python, AI platforms, and insurance tech.';

  if (query.toLowerCase().includes('rent prompts') || query.toLowerCase().includes('dyaus tech')) {
    title = 'Ayush Sharma | Dyaus Tech | Full-Stack Developer';
  } else if (query.toLowerCase().includes('crum and forster') || query.toLowerCase().includes('cnf')) {
    title = 'Ayush Sharma | Crum & Forster (CNF) | Full-Stack Developer';
  }

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content="Ayush Sharma" />
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://aayushsharma.tech/Profile.jpg" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://aayushsharma.tech" />
      <meta property="og:image" content="https://aayushsharma.tech/Profile.jpg" />
      <meta property="og:image:alt" content="Ayush Sharma" />
      <meta property="og:locale" content="en_US" />

      {/* Canonical URL */}
      <link rel="canonical" href="https://aayushsharma.tech" />

      {/* Additional */}
      <meta
        name="keywords"
        content="Ayush Sharma, Crum & Forster, CNF Insurance, Dyaus Tech, Rent Prompts, Full-Stack Developer Indore, MERN Stack Developer, React Developer, Node.js Developer, Python Developer, Insurance Technology, AI Chatbots, Software Developer India, Ujjain Engineering College Alumni"
      />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "Ayush Sharma",
          "url": "https://aayushsharma.tech",
          "image": "https://aayushsharma.tech/Profile.jpg",
          "sameAs": [
            "https://www.linkedin.com/in/ayush-s-673990130/",
            "https://github.com/Ayushaff"
          ],
          "jobTitle": "Full-Stack Developer",
          "worksFor": {
            "@type": "Organization",
            "name": "Crum & Forster",
            "url": "https://www.cfins.com/"
          },
          "alumniOf": {
            "@type": "EducationalOrganization",
            "name": "Ujjain Engineering College, Ujjain, Madhya Pradesh, India"
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Indore",
            "addressRegion": "Madhya Pradesh",
            "addressCountry": "India"
          },
          "hasOccupation": [
            {
              "@type": "Occupation",
              "name": "Full-Stack Developer",
              "hiringOrganization": {
                "@type": "Organization",
                "name": "Crum & Forster",
                "url": "https://www.cfins.com/"
              },
              "startDate": "2025-01-01"  // Update to actual start date if known
            },
            {
              "@type": "Occupation",
              "name": "Full-Stack Developer",
              "hiringOrganization": {
                "@type": "Organization",
                "name": "Dyaus Tech",
                "url": "https://rentprompts.ai/"
              },
              "startDate": "2024-04-01",
              "endDate": "2025-07-31"
            }
          ]
        })}
      </script>
    </Helmet>
  );
};